import React from "react";
import { Button, Form, FormGroup, Pagination, Icon } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import Components from "mpm-components";
import * as Constants from "mpm-config/Constants";
import { DateInput } from "semantic-ui-calendar-react";
import Utilities from "mpm-config/Utilities";
import { isMobile } from "react-device-detect";
export default ({
  searchData,
  updateSearchData,
  data,
  pagination,
  onPageChange,
  onClickAdd,
  onClickSearch,
  onClickEdit,
  onClickView,
  onClickReset,
  onClickDelete,
  loading,
}) => {
  const [searchCretaria, setSearchCretaria] = React.useState(searchData);
  React.useEffect(() => {
    setSearchCretaria(searchData);
  }, [searchData]);
  const onInputChange = (e, { name, value }) => {
    let newSearch = {
      ...searchCretaria,
      [name]: value,
    };
    setSearchCretaria(newSearch);
    updateSearchData(newSearch);
  };

  return (
    <>
      <Components.Regions.RegionWithHeader
        title="label.search-cretaria"
        headerColor="blue"
        headerSize="small"
        className={isMobile && "overflow"}
        headerAction={
          <Button
            onClick={onClickAdd}
            content={<FormattedMessage tagName="label" id="label.add" />}
            color="blue"
            icon="plus"
            size="tiny"
            labelPosition="left"
          />
        }
        rightFooter={
          <div>
            <Button
              content={<FormattedMessage tagName="label" id="label.reset" />}
              color="red"
              icon="sync alternate"
              labelPosition="left"
              size="tiny"
              onClick={() => onClickReset()}
            />
            <Button
              content={<FormattedMessage tagName="label" id="label.search" />}
              loading={loading}
              color="green"
              icon="search"
              labelPosition="left"
              size="tiny"
              onClick={() => onClickSearch()}
            />
          </div>
        }
      >
        <Form>
          <FormGroup widths="equal">
            <Form.Input
              label={
                <FormattedMessage tagName="label" id="label.numero-cession" />
              }
              type="text"
              name="numeroCessionComplet"
              value={searchCretaria.numeroCessionComplet}
              onChange={onInputChange}
            />
            <Form.Select
              name="typeAcquereur"
              value={searchCretaria.typeAcquereur}
              clearable
              label={
                <FormattedMessage tagName="label" id="label.type-acquereur" />
              }
              options={Utilities.getTypeAcquereurCCDropDownOptions()}
              onChange={onInputChange}
            />
            <Form.Input
              label={
                <FormattedMessage tagName="label" id="label.login-acquereur" />
              }
              type="text"
              name="numeroAcquereur"
              value={searchCretaria.numeroAcquereur}
              onChange={onInputChange}
            />
           
          </FormGroup>
          <FormGroup widths="equal">
            <DateInput
              label={
                <FormattedMessage tagName="label" id="label.period-from" />
              }
              clearable
            closable
              type="text"
              name="dateCessionDu"
              icon="calendar"
              iconPosition="right"
              maxDate={searchCretaria.dateCessionAu}
              value={searchCretaria.dateCessionDu}
              onChange={onInputChange}
              animation="fade"
              autoComplete="off"
              dateFormat="DD/MM/YYYY"
            />
            <DateInput
              label={<FormattedMessage tagName="label" id="label.period-to" />}
              clearable
            closable
              type="text"
              name="dateCessionAu"
              icon="calendar"
              iconPosition="right"
              minDate={searchCretaria.dateCessionDu}
              value={searchCretaria.dateCessionAu}
              onChange={onInputChange}
              animation="fade"
              autoComplete="off"
              dateFormat="DD/MM/YYYY"
            />
              <Form.Select
              name="etat"
              clearable
              label={<FormattedMessage tagName="label" id="label.etat" />}
              value={searchCretaria.etat}
              options={Utilities.getCessionCaptureAcquereurEtatsDropDownOptions()}
              onChange={onInputChange}
            />
          </FormGroup>
        </Form>
      </Components.Regions.RegionWithHeader>

      {data && data.length > 0 ? (
        <Components.Regions.RegionWithHeader
          title="label.table-results"
          headerColor="blue"
          headerSize="small"
          loading={loading}
        >
          <Components.Tables.SmartTable
            header={[
              {
                selector: "numeroCessionComplet",
                textAlign: "center",
                label: (
                  <FormattedMessage
                    tagName="label"
                    id="label.table.numero-cession"
                  />
                ),
              },
              {
                selector: "dateCession",
                textAlign: "center",
                label: (
                  <FormattedMessage
                    tagName="label"
                    id="label.table.date-cession"
                  />
                ),
              },
              {
                selector: "acquereurCCDTO.typeAcquereur",
                textAlign: "center",
                label: (
                  <FormattedMessage
                    tagName="label"
                    id="label.table.type-acquereur"
                  />
                ),
                component: (row) => (
                  <>
                    {Utilities.getTypeAcquereurCCDropDownOptions().map(
                      (elem) =>
                        row.acquereurCCDTO.typeAcquereur === elem.value && (
                          <span>{elem.text}</span>
                        )
                    )}
                  </>
                ),
              },
              {
                selector: "acquereurCCDTO.acquereur",
                textAlign: "center",
                label: (
                  <FormattedMessage
                    tagName="label"
                    id="label.table.acquereur"
                  />
                ),
              },
              {
                selector: "etat",
                textAlign: "center",
                label: (
                  <FormattedMessage tagName="label" id="label.table.etat" />
                ),
                component: (row) => (
                  <>{Utilities.getCessionCaptureEtatLabel(row.etat)}</>
                ),
              },
              {
                label: (
                  <FormattedMessage tagName="label" id="label.table.actions" />
                ),
                collapsing: true,
                component: (row) => (
                  <>
                    <Button
                      basic
                      size="mini"
                      onClick={() => onClickView(row.id)}
                      icon
                    >
                      {" "}
                      <Icon name="eye" />{" "}
                    </Button>
                    {Utilities.isCedantAutorized(row.etat) && (
                      <>
                        <Button
                          basic
                          size="mini"
                          onClick={() => onClickEdit(row.id)}
                          color="blue"
                          icon
                        >
                          {" "}
                          <Icon name="edit" />{" "}
                        </Button>
                        <Button
                          basic
                          size="mini"
                          onClick={() => onClickDelete(row)}
                          color="red"
                          icon
                        >
                          {" "}
                          <Icon name="trash" />{" "}
                        </Button>
                      </>
                    )}
                  </>
                ),
              },
            ]}
            data={data}
            grouped={false}
            striped={true}
            pagination={false}
            rowsPerPage={Constants.DEFAULT_TABLE_ROWS}
          />
          <Pagination
            activePage={pagination.page}
            totalPages={pagination.totalPages}
            onPageChange={(e, { activePage }) => onPageChange(activePage)}
          />
        </Components.Regions.RegionWithHeader>
      ) : null}
    </>
  );
};

